var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStopPriority(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.286 0.72816C11.678 0.328341 12.322 0.328341 12.714 0.72816L16.89 4.98689C16.9681 5.06652 17.0589 5.13253 17.1588 5.18218L22.4995 7.83775C23.0009 8.08706 23.1999 8.69946 22.9408 9.19587L20.1809 14.4835C20.1293 14.5823 20.0946 14.6891 20.0783 14.7995L19.2031 20.6994C19.1209 21.2533 18.6 21.6318 18.0478 21.5388L12.1661 20.548C12.0561 20.5295 11.9439 20.5295 11.8339 20.548L5.95223 21.5388C5.40004 21.6318 4.8791 21.2533 4.79693 20.6994L3.92172 14.7995C3.90535 14.6891 3.87065 14.5823 3.81905 14.4835L1.0592 9.19587C0.800102 8.69946 0.999084 8.08706 1.50048 7.83775L6.84123 5.18218C6.94109 5.13253 7.03193 5.06652 7.11001 4.98689L11.286 0.72816Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStopPriority);
export default __webpack_public_path__ + "static/media/stop-priority.ae5ea598cb5739391b77a79a664b7e40.svg";
export { ForwardRef as ReactComponent };